export default __webpack_public_path__ + "static/media/miguel-lopes-39.a0436972.jpg";